import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import compose from '@hypnosphi/recompose/compose';
import { withStyles } from '@mui/styles';
import TextEditor from "../../texteditor";
import Tooltip from 'apollo-react/components/Tooltip';
import Select from "apollo-react/components/Select";
import MenuItem from "apollo-react/components/MenuItem";
import Counter from "../../counter";
import { usePostmongerContext } from '../../../contexts/PostmongerContext';


const styles = {
    section: {
      marginBottom: 32,
    },
  };

export const validateAndRoundDueDate = (value) =>
  {
    let numValue = Math.round(Number(value));
    if(numValue > 99)
    {
      return 99;
    }
    if(numValue < 1)
    {
      return 1;
    }
    return numValue;
  }

export const ToDo = (props, ref) => {  
  const { classes } = props;

  const { t } = useTranslation();
  const { inArguments, setDirty, seedData, disabled } = usePostmongerContext();

    const defaultProfiles = () => (inArguments.get("targetUserProfiles") || []);
    const defaultProducts = () => (inArguments.get("targetProductIds") || []);
  const [todoName, setTodoMessage] = useState(inArguments.get("todoName") || "");
  const [todoDescription, setTodoDescription] = useState(inArguments.get("todoDescription") || "");
  const [todoDueDate, setTodoDueDate] = useState(inArguments.get("todoDueDate") || "");
    const [repProfiles, setRepProfiles] = useState(defaultProfiles());
    const [targetProducts, setTargetProducts] = useState(defaultProducts());
  
  const todoFields = seedData.OCEPersonal.todoFields;
  const todoDescriptionFields = seedData.OCEPersonal.todoDescriptionFields;
    const profilesList = seedData.OCEPersonal.profilesResult;
    const productsList = seedData.Products.products;// [{ Id: "001", Name: "Test 1" }, { Id: "002", Name: "Test 2" }];

  

  const validateOnChangeName = (value) => 
  {
    let name = value;
    todoFields.forEach(todoField => {
      let field = '$(' + todoField + ')';
      name = name.replace(field,'');
    });
    if(name.length > 50)
    {
      return false;
    }
    return true;
  }
  const GetDefaultProfile = () => {
    const profile = [];
    for (let item of profilesList) {
      if (item.Name == "Sales Representative") {
        profile.push(item.Id);
      }
    }
    console.log(profile);
    return profile;
    };

    useEffect(() =>
    {
      if (typeof repProfiles === "undefined" || (Array.isArray(repProfiles) && repProfiles.length === 0)) {
          var defaultProf = GetDefaultProfile();
          setRepProfiles(defaultProf);
          inArguments.set("targetUserProfiles", defaultProf);
          setDirty();
      }
    }, [])


  const GetProfileMenuItems = () => {
    const items = [];
    for (let item of profilesList) {
      items.push(
        <MenuItem key={item.Id} value={item.Id}>
          {item.Name}
        </MenuItem>
      );
    }
    return items;
    };
    
    const GetTargetProductsMenuItems = () => {
        const items = [];
        for (let item of productsList) {
          items.push(
            <MenuItem key={item.ProductId} value={item.ProductId}>
              {item.ProductName}
            </MenuItem>
          );
        }
        return items;
      };

  const [userProfileMenuItems, setUserProfileMenuItems] = useState(
    GetProfileMenuItems()
    );
    const [targetProductsMenuItems, setTargetProductsMenuItems] = useState(
        GetTargetProductsMenuItems()
        );
    

  useEffect(() => {
      setUserProfileMenuItems(GetProfileMenuItems());
      setTargetProductsMenuItems(GetTargetProductsMenuItems());
  }, [seedData]);

  const onChangeUserProfile = (event) => {
    const value = event.target.value;
    setRepProfiles(value);
    inArguments.set("targetUserProfiles", value);
    setDirty();
    console.log(repProfiles);
    };
  const onChangeTargetProducts = (event) => {
        const value = event.target.value;
        setTargetProducts(value);
        inArguments.set("targetProductIds", value);
        setDirty();
        console.log(targetProducts);
      };

  const onChangeName = event => {
    const value = event.target.value;
    if(validateOnChangeName(value))
    {
      setTodoMessage(value);
      inArguments.set('todoName', value)
      setDirty();
    }
  };
  const onChangeTodoDescription = event => {
    const value = event.target.value;
      setTodoDescription(value);
      inArguments.set('todoDescription', value)
      setDirty();
  };
  const onChangeDueDate = event => {
    let input = event.target.value;
    if (event.target.value !== '')
    {
      input = validateAndRoundDueDate(input);
    }
    const value = input.toString(10);
    if (typeof value === "undefined" || typeof value !== "number"){
      setTodoDueDate(value);
      inArguments.set('todoDueDate', value)
      setDirty();
    }
  };

  useImperativeHandle(ref, () => ({ isValid }));

  const isValid = () => {
    return isNameValid() && isProfilesValid();
  };

  const isNameValid = () => {
    const title = inArguments.get("todoName");
    if (title === undefined) return false;
    else if (title.length < 1) return false;
    return true;
  };
  const isProfilesValid = () => {
    const profiles = inArguments.get("targetUserProfiles");
    if (profiles === [] || profiles.length < 1) return false;
    return true;
    };


  return (
    <div className={classes.section}>
      
      <TextEditor
        fullWidth
        label={t('ocepersonal.todo.nameCaption')}
        tooltip={t('ocepersonal.todo.nameTooltip')}
        required
        minRows="1"
        maxRows="1"
        value={todoName}
        name="todoName"
        disabled={disabled}
        onChange={onChangeName}
        fields={todoFields}
        error={!isNameValid()}
        inputProps={{ maxLength: 80 }}
      />     

      <TextEditor
        fullWidth
        label={t("ocepersonal.todo.todoDescriptionCaption")}
        tooltip={t("ocepersonal.todo.todoDescriptionTooltip")}
        multiline
        minRows="4"
        maxRows="4"
        value={todoDescription}
        name="todoDescription"
        disabled={disabled}
        onChange={onChangeTodoDescription}
        fields={todoDescriptionFields}
        inputProps={{ maxLength: 2000 }}
      />
      
      <Tooltip title={t('ocepersonal.todo.dateTooltip')}>
        <Counter 
          msgPrefix="In"
          msgSuffix="days."
          minValue="1"
          maxValue="99"
          inputLabel="Due Date"
          onChange={onChangeDueDate}
          disabled={disabled}
          value={todoDueDate} /> 
      </Tooltip>

      <Tooltip title={t('ocepersonal.todo.targetUserCaption')}>
        <Select
          label={t('ocepersonal.todo.targetUserCaption')}
          multiple
          fullWidth
          required
          onChange={onChangeUserProfile}
          placeholder="Target User Profile(s)"
          disabled={disabled}
          value={repProfiles}
        >
          {userProfileMenuItems}
        </Select>
          </Tooltip>
          
      <Tooltip title={t('ocepersonal.todo.targetProductCaption')}>
        <Select
          label={t('ocepersonal.todo.targetProductCaption')}
          multiple
          fullWidth
          onChange={onChangeTargetProducts}
          placeholder={t('ocepersonal.todo.targetProductPlaceholder')}
          disabled={disabled}
          value={targetProducts}
        >
          {targetProductsMenuItems}
        </Select>
      </Tooltip>

    </div>);
};

export default compose(withStyles(styles))(forwardRef(ToDo));